export default {
  user: null,
  messages: null,
  current_user: null,
  current_user_parents: {},
  companyChart: false,
  error: false,
  errorMessage: ""
};
